module.exports = [{"aaaa":"1234"}]


//////////////////
// WEBPACK FOOTER
// ./static/test.json
// module id = A2HN
// module chunks = 16